import { Inject, Injectable } from '@angular/core';
import { ApiClientConfig } from '@pt/api-client';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorDependencyService {
  private readonly endpoint;

  constructor(@Inject(ApiClientConfig) private config,
              private httpClient: HttpClient) {
    this.endpoint = this.config.endPoint;
  }

  public findById(path: string): Observable<any> {
    const url = this.endpoint + path;
    return this.httpClient.get<any>(url);
  }
}
